var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_c('td',{staticClass:"text-right font-weight-bold",attrs:{"colspan":_vm.headers.length - 3}},[_vm._v(" Total ")]),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.total))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }